module.exports = __webpack_public_path__ + "static/media/ten.17027e1e.png";